import { wareHouseReceiptsTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  milestoneConfig: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const warehouseReceipts = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case wareHouseReceiptsTypes.GET_WAREHOUSERECEIPTS:
      return {
        ...state,
        isLoading: true,
      };
    case wareHouseReceiptsTypes.GET_WAREHOUSERECEIPTS_SUCCESS:
      return {
        ...state,
        data: action.payload.wharehouseReceiptData,
        CountItems: action.payload.CountItems,
        isLoading: false,
      };

    case wareHouseReceiptsTypes.GET_WAREHOUSERECEIPTS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case wareHouseReceiptsTypes.GET_MILESTONESCONFIG_WR_SUCCESSS:
        return{
          ...state,
          milestoneConfig: action.payload
        }
  
    case wareHouseReceiptsTypes.GET_MILESTONESCONFIG_WR_FAIL:
          return{
            ...state,
            error: action.payload,
          }

    default:
      return state;
  }
};

export default warehouseReceipts;
